import { Inject, Injectable } from '@angular/core';
import { LaneControlModule } from '../../../control/lane-control.module';
import { MasterVehiclesModule } from '../../../master-vehicles/master-vehicles.module';

@Injectable()
export class NavigationMenuService {
  activeModules: any[];

  constructor(@Inject('menu') menu: string) {}
}
